import { isPermissionAllowed } from '../api/userPermissions';
import { localI18n } from '../i18n';
export let PermissionValue = function (PermissionValue) {
  PermissionValue["CAN_COMMENT"] = "can_comment";
  PermissionValue["CAN_EDIT"] = "can_edit";
  PermissionValue["CAN_VIEW"] = "can_view";
  return PermissionValue;
}({});
export let PermissionValueNoAccess = function (PermissionValueNoAccess) {
  PermissionValueNoAccess["NO_ACCESS"] = "no_access";
  return PermissionValueNoAccess;
}({});
const permissionPrecedentMap = {
  [PermissionValue.CAN_VIEW]: 0,
  [PermissionValue.CAN_COMMENT]: 1,
  [PermissionValue.CAN_EDIT]: 2
};
const permissionUxCopy = {
  [PermissionValue.CAN_VIEW]: localI18n._("can view"),
  [PermissionValue.CAN_COMMENT]: localI18n._("can comment"),
  [PermissionValue.CAN_EDIT]: localI18n._("can edit")
};
const explicitPermissionOptionMap = {
  [PermissionValue.CAN_VIEW]: [{
    value: PermissionValue.CAN_VIEW,
    label: permissionUxCopy[PermissionValue.CAN_VIEW]
  }],
  [PermissionValue.CAN_COMMENT]: [{
    value: PermissionValue.CAN_COMMENT,
    label: permissionUxCopy[PermissionValue.CAN_COMMENT]
  }],
  [PermissionValue.CAN_EDIT]: [{
    value: PermissionValue.CAN_EDIT,
    label: permissionUxCopy[PermissionValue.CAN_EDIT]
  }]
};
const permissionOptionMap = {
  [PermissionValue.CAN_VIEW]: [{
    value: PermissionValue.CAN_VIEW,
    label: permissionUxCopy[PermissionValue.CAN_VIEW]
  }],
  [PermissionValue.CAN_COMMENT]: [{
    value: PermissionValue.CAN_VIEW,
    label: permissionUxCopy[PermissionValue.CAN_VIEW]
  }, {
    value: PermissionValue.CAN_COMMENT,
    label: permissionUxCopy[PermissionValue.CAN_COMMENT]
  }],
  [PermissionValue.CAN_EDIT]: [{
    value: PermissionValue.CAN_VIEW,
    label: permissionUxCopy[PermissionValue.CAN_VIEW]
  }, {
    value: PermissionValue.CAN_COMMENT,
    label: permissionUxCopy[PermissionValue.CAN_COMMENT]
  }, {
    value: PermissionValue.CAN_EDIT,
    label: permissionUxCopy[PermissionValue.CAN_EDIT]
  }]
};
export default class CollaboratorPermission {
  constructor(value) {
    this.value = value;
    this.permissionValue = value === PermissionValueNoAccess.NO_ACCESS ? PermissionValue.CAN_VIEW : value;
    this.uxCopy = permissionUxCopy[this.permissionValue];
    this.precedence = permissionPrecedentMap[this.permissionValue];
  }
  static fromAccessRight(accessRight) {
    if (isPermissionAllowed(accessRight.editor)) {
      return new CollaboratorPermission(PermissionValue.CAN_EDIT);
    }
    if (isPermissionAllowed(accessRight.commenter)) {
      return new CollaboratorPermission(PermissionValue.CAN_COMMENT);
    }
    if (isPermissionAllowed(accessRight.viewer)) {
      return new CollaboratorPermission(PermissionValue.CAN_VIEW);
    }
    return new CollaboratorPermission(PermissionValueNoAccess.NO_ACCESS);
  }
  static fromPermissionType(permission) {
    if (permission.can_edit) {
      return new CollaboratorPermission(PermissionValue.CAN_EDIT);
    }
    if (permission.can_comment) {
      return new CollaboratorPermission(PermissionValue.CAN_COMMENT);
    }
    if (permission.can_view) {
      return new CollaboratorPermission(PermissionValue.CAN_VIEW);
    }
    return undefined;
  }
  permissionOption() {
    return explicitPermissionOptionMap[this.permissionValue];
  }
  permissionOptions() {
    return permissionOptionMap[this.permissionValue];
  }
  hasEditRight() {
    return this.value === PermissionValue.CAN_EDIT;
  }
  hasNoAccess() {
    return this.value === PermissionValueNoAccess.NO_ACCESS;
  }
  greaterThan(other) {
    return this.precedence > other.precedence;
  }
  greaterOrEqualThan(other) {
    return this.precedence >= other.precedence;
  }
  lessThan(other) {
    return this.precedence < other.precedence;
  }
  lessOrEqualThan(other) {
    return this.precedence <= other.precedence;
  }
}
export const getPermissionOptionsUpdate = (currentUserUpdateRights, otherUserPermission, isOwner) => {
  const currentUserUpdatePermission = CollaboratorPermission.fromAccessRight(currentUserUpdateRights);
  if (isOwner || currentUserUpdatePermission.hasEditRight()) {
    return {
      disabled: false,
      options: currentUserUpdatePermission.permissionOptions()
    };
  }
  if (currentUserUpdatePermission.hasNoAccess() || otherUserPermission.greaterOrEqualThan(currentUserUpdatePermission)) {
    return {
      disabled: true,
      options: otherUserPermission.permissionOption()
    };
  } else {
    return {
      disabled: false,
      options: otherUserPermission.permissionOptions()
    };
  }
};